import React from "react";
import { Heart, Bookmark, FolderPlus, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const PromptSavingDemo: React.FC = () => {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-secondary/20">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Build Your Personal Prompt Library
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Save, organize, and access your favorite prompts instantly. Never lose a great prompt again.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Demo Visual */}
          <div className="space-y-4">
            <Card className="relative overflow-hidden">
              <CardHeader className="border-b">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold">Email Marketing Prompt</h3>
                    <p className="text-sm text-muted-foreground">Perfect for product launches</p>
                  </div>
                  <div className="flex gap-2">
                    <Button size="sm" variant="outline" className="bg-red-50 text-red-600 border-red-200 hover:bg-red-100">
                      <Heart className="h-4 w-4" />
                    </Button>
                    <Button size="sm" variant="outline" className="bg-blue-50 text-blue-600 border-blue-200 hover:bg-blue-100">
                      <Bookmark className="h-4 w-4" />
                    </Button>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="p-4">
                <div className="bg-gray-50 p-3 rounded text-sm font-mono">
                  Create a compelling email for launching [product]...
                </div>
                <div className="flex gap-2 mt-3">
                  <Badge variant="secondary">Marketing</Badge>
                  <Badge variant="secondary">Email</Badge>
                </div>
              </CardContent>
            </Card>
            
            <div className="flex items-center justify-center">
              <ArrowRight className="h-6 w-6 text-primary animate-pulse" />
            </div>
            
            <Card className="bg-green-50 border-green-200">
              <CardContent className="p-4">
                <div className="flex items-center gap-2 text-green-700">
                  <FolderPlus className="h-5 w-5" />
                  <span className="font-medium">Saved to "Marketing Campaign" folder</span>
                </div>
              </CardContent>
            </Card>
          </div>
          
          {/* Benefits */}
          <div className="space-y-6">
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 rounded-full p-2 mt-1">
                  <Bookmark className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Instant Organization</h3>
                  <p className="text-muted-foreground">
                    Automatically categorize and tag your saved prompts for easy retrieval
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 rounded-full p-2 mt-1">
                  <FolderPlus className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Custom Collections</h3>
                  <p className="text-muted-foreground">
                    Create personalized folders for different projects and use cases
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 rounded-full p-2 mt-1">
                  <Heart className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Quick Access</h3>
                  <p className="text-muted-foreground">
                    One-click access to your most-used prompts from anywhere
                  </p>
                </div>
              </div>
            </div>
            
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <p className="text-blue-800 font-medium">Pro Tip: Premium users get unlimited saves </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default PromptSavingDemo;